import { registerBlockType } from "@wordpress/blocks";
import metadata from "./block.json";
import Edit from "./Edit";
import Save from "./save";

registerBlockType(metadata.name, {
  edit: Edit,
  save: Save,
  icon: {
    foreground: "#0061FE",
    src: (
      <svg
        id="a"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <path
          d="m21.4,4.3c-.4-.7-1-1.3-1.7-1.7-.8-.4-1.7-.4-3.5-.4H7.8c-1.8,0-2.7,0-3.5.4-.7.4-1.3,1-1.7,1.7-.4.8-.4,1.7-.4,3.5v8.4c0,1.8,0,2.7.4,3.5.4.7,1,1.3,1.7,1.7.8.4,1.7.4,3.5.4h4.6c.4,0,.8-.4.8-.8s-.4-.8-.8-.8h-4.6c-1.5,0-2.3,0-2.8-.2-.4-.2-.7-.5-1-1-.2-.5-.2-1.3-.2-2.8V7.8c0-1.5,0-2.3.2-2.8.2-.4.5-.7,1-1,.4-.2,1.1-.2,2.2-.2v.7c0,1,.8,1.8,1.8,1.8h6c1,0,1.8-.8,1.8-1.8v-.7c1.2,0,1.8,0,2.2.2.4.2.7.5,1,1,.2.5.2,1.3.2,2.8v4.6c0,.4.4.8.8.8s.8-.4.8-.8v-4.6c0-1.8,0-2.7-.4-3.5Zm-6.4.4h-6c-.1,0-.2-.1-.2-.2v-.7h6.5v.7c0,.17-.2.2-.3.2Z"
          stroke-width="0"
        />
        <path
          d="m19.89,15.3l-5.51-1.83c-.33-.11-.49-.16-.6-.12-.09.03-.17.11-.2.2-.04.11.02.27.12.6l1.83,5.51c.12.37.18.56.29.62.09.06.2.07.3.03.11-.05.21-.22.39-.56l1.14-2.11c.03-.05.04-.08.06-.1.02-.02.03-.04.06-.06.02-.02.05-.03.1-.06l2.11-1.14c.35-.19.52-.28.56-.39.04-.1.03-.21-.03-.3-.06-.1-.25-.17-.62-.29Z"
          stroke-width="0"
        />
      </svg>
    ),
  },
});
